import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, map, take, filter, of, catchError, timeout } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class EditorGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(): Observable<boolean> {
    // console.log('EditorGuard - Iniciando validación...');
    
    return this.authService.currentUser$.pipe(
      // Esperar hasta que el estado de autenticación sea definitivo (no 'undefined')
      filter(user => user !== undefined),
      take(1), // Tomar el primer valor definitivo y cancelar la suscripción
      map(currentUser => {
        // console.log('EditorGuard - Usuario final para validación:', currentUser);
        
        if (!currentUser) {
          // console.log('EditorGuard - No hay usuario autenticado, redirigiendo a login');
          this.router.navigate(['/login']);
          return false;
        }
        
        // Permitir acceso a administradores y editores generales
        const isAllowed = ['admin', 'general_editor'].includes(currentUser.role);
        // console.log('EditorGuard - ¿Tiene permisos de editor?:', isAllowed);
        
        if (!isAllowed) {
          // console.log('EditorGuard - Acceso denegado: usuario no tiene permisos de editor');
          this.authService.logout();
          return false;
        }

        // Validar si tiene acceso al dominio actual
        try {
          const hasAccess = this.authService.isAccessAllowedForCurrentDomain(currentUser.role);
          if (!hasAccess) {
            // console.log('EditorGuard - Acceso denegado por dominio');
            this.authService.logout();
            return false;
          }
        } catch (error) {
          // console.error('EditorGuard - Error validando acceso:', error);
          this.authService.logout();
          return false;
        }
        
        // console.log('EditorGuard - Acceso permitido para:', currentUser.name);
        return true;
      }),
      timeout(15000), // Timeout de 15 segundos por si algo sale mal
      catchError(error => {
        // console.error('EditorGuard - Error o timeout. Redirigiendo a login.', error);
        this.router.navigate(['/login']);
        return of(false);
      })
    );
  }
} 